import { defineTokens } from "@chakra-ui/react";

export const spacing = defineTokens.spacing({
  "0.5": {
    value: "0.2rem",
  },
  "1": {
    value: "0.4rem",
  },
  "1.5": {
    value: "0.6rem",
  },
  "2": {
    value: "0.8rem",
  },
  "3": {
    value: "1.2rem",
  },
  "4": {
    value: "1.6rem",
  },
  "5": {
    value: "2rem",
  },
  "6": {
    value: "2.4rem",
  },
  "7": {
    value: "2.8rem",
  },
  "8": {
    value: "3.2rem",
  },
  "9": {
    value: "3.6rem",
  },
  "10": {
    value: "4rem",
  },
  "11": {
    value: "4.4rem",
  },
  "12": {
    value: "4.8rem",
  },
  "14": {
    value: "5.6rem",
  },
  "16": {
    value: "6.4rem",
  },
  "20": {
    value: "8rem",
  },
  "24": {
    value: "9.6rem",
  },
  "28": {
    value: "11.2rem",
  },
  "32": {
    value: "12.8rem",
  },
  "36": {
    value: "14.4rem",
  },
  "40": {
    value: "16rem",
  },
  "44": {
    value: "17.6rem",
  },
  "48": {
    value: "19.2rem",
  },
  "52": {
    value: "20.8rem",
  },
  "56": {
    value: "22.4rem",
  },
  "60": {
    value: "24rem",
  },
  "64": {
    value: "25.6rem",
  },
  "72": {
    value: "28.8rem",
  },
  "80": {
    value: "32rem",
  },
  "96": {
    value: "38.4rem",
  },
});
